import React from 'react'
import ReactToPrint from "react-to-print";
import companylogo from "../../assets/company.png"

const CreditDebitPreview = (props) => {
    const componentRef = React.createRef();
    return (
        <>
            <div className="invoice__preview bg-white p-5 rounded-2xl border-4 border-blue-200">
                <ReactToPrint
                    trigger={() => (
                        <button className="bg-blue-500 ml-5 text-white font-bold py-2 px-8 rounded hover:bg-blue-600 hover:text-white transition-all duration-150 hover:ring-4 hover:ring-blue-400">
                            Print / Download
                        </button>
                    )}
                    content={() => componentRef.current}
                />

                <div ref={componentRef} className="bg-white p-6 relative min-h-[1050px]">
                    <div className="flex flex-col items-center justify-center mb-5 xl:flex-row xl:justify-center w-full">
                        <div>

                            <img  src={companylogo} alt="logo" />
                        </div>
                    </div>
                    <div className="flex flex-col justify-between mb-4">
                        {/* <div className="font-bold">{props.tel || "Tel: 44605198"}</div>
                        <div className="font-bold">{props.fax || "Fax: 44517172"}</div>
                        <div className="font-bold">{props.box || "PO Box: 40992"}</div> */}
                        <div className="font-bold">{props.clientaddress || "INDUSTRIAL AREA GATE 130"}</div>
                    </div>
                    <div className="border border-gray-300 p-4 mb-4">
                        <div>{props.clientname || "DESERT LINE SANAYYA"}</div>
                    </div>
                    <div className="flex justify-between mb-4 mt-4">
                        <div className="flex justify-center items-center border border-gray-300 p-2 rounded-md">
                            <label htmlFor="debitNote" className={`${props.debitNote ? "ml-2" : ""}`}>Debit Note</label>
                            {props.debitNote && (<svg className="ml-2 h-6 w-6 text-green-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M17.293 4.293a1 1 0 011.414 1.414l-11 11a1 1 0 01-1.414 0l-7-7a1 1 0 111.414-1.414L6 13.086l10.293-10.293a1 1 0 011.414 0z" clipRule="evenodd" />
                            </svg>)}
                        </div>
                        <div className="flex justify-center items-center border border-gray-300 p-2 rounded-md">
                            <label htmlFor="creditNote" className={`${props.creditNote ? "ml-2" : ""}`}>Credit Note</label>
                            {props.creditNote && (<svg className="ml-2 h-6 w-6 text-green-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M17.293 4.293a1 1 0 011.414 1.414l-11 11a1 1 0 01-1.414 0l-7-7a1 1 0 111.414-1.414L6 13.086l10.293-10.293a1 1 0 011.414 0z" clipRule="evenodd" />
                            </svg>)}
                        </div>
                    </div>
                    <table className="w-full border-collapse">
                        <tbody>
                            <tr>
                                <td className="font-semibold p-2 border border-gray-300">DATE:</td>
                                <td className="p-2 border border-gray-300">{props.date.slice(0,10) || "04/Sep/2023"}</td>
                                <td className="font-semibold p-2 border border-gray-300">Doc No:</td>
                                <td className="p-2 border border-gray-300">{props.docNo || "MIT23CRN000010"}</td>
                            </tr>


                            <tr>
                                <td className="font-semibold p-2 border border-gray-300">REF NO#</td>
                                <td className="font-semibold p-2 border border-gray-300">DESCRIPTION</td>
                                <td className="font-semibold p-2 border border-gray-300">DEBIT</td>
                                <td className="font-semibold p-2 border border-gray-300">CREDIT</td>
                            </tr>
                            <tr>
                                <td className="font-semibold text-center p-2 border border-gray-300">

                                </td>
                                <td className="font-semibold p-2 border border-gray-300">
                                    <p className='uppercase font-bold underline'>WE HAVE CREDITED YOU WITH THE FOLLOWING</p>
                                    {props.description || "DISCOUNT FOR BROKAGE GLASS (JOB NO. 4161) INV DATE 21/06/2023"}
                                </td>
                                <td className="font-semibold text-center p-2 border border-gray-300">
                                    {props.debitNote ? (props.debitAmount || "3,740.00") : ""}
                                </td>
                                <td className="font-semibold text-center p-2 border border-gray-300">
                                    {props.creditNote ? (props.creditAmount || "3,740.00") : ""}
                                </td>
                            </tr>



                            <tr>
                                <td className="font-semibold text-center p-2">

                                </td>
                                <td className="font-semibold text-end p-2">
                                    <p className='uppercase font-bold underline'>TOTAL:</p>
                                    <p className='font-bold'>QR. {"(Three Thousand Seven Hundred Forty Only)"}</p>
                                </td>
                                <td className="font-semibold text-center p-2">
                                    {props.debitNote ? (props.debitAmount || "3,740.00") : ""}
                                </td>
                                <td className="font-semibold text-center p-2">
                                    {props.creditNote ? (props.creditAmount || "3,740.00") : ""}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <footer className="absolute bottom-0 left-0 right-0 footer border-gray-300 pb-5">
                        <div className="w-full flex justify-evenly pt-4 pb-14 px-5 border-b border-gray-300 mb-2 text-base">
                            <p className='uppercase font-bold'>Accountant</p>
                            <p className='uppercase font-bold'>Authorised By</p>
                            <p className='uppercase font-bold'>Received By</p>
                        </div>
                        <ul className="flex flex-wrap items-center gap-2 justify-center">
                            <li>
                                <span className="font-bold">Email:</span> {"arcoglassqatar@gmail.com"}
                            </li>
                            <li>
                                <span className="font-bold">Tel:</span> {"4460 5198"}<span className="ml-1 font-bold">-Fax:</span> {"4451 7172"}
                            </li>
                            <li>
                                <span className="font-bold">P.O Box:</span> {"40992, Doha-Qatar "}
                            </li>
                        </ul>
                    </footer>
                </div>

            </div>
        </>
    );
}

export default CreditDebitPreview